<template>
  <div>
    <a-card class="card">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="工商">
          <business />
        </a-tab-pane>
        <a-tab-pane key="2" tab="司法">
          <judicial />
        </a-tab-pane>
        <a-tab-pane key="3" tab="经营">
          <manage />
        </a-tab-pane>
        <a-tab-pane key="4" tab="失信">
          <unpromise />
        </a-tab-pane>
        <a-tab-pane key="5" tab="舆情">
          <public-opinion />
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import business from './components/business/business'
import judicial from './components/judicial/judicial'
import manage from './components/manage/manage'
import unpromise from './components/unpromise/index'
import publicOpinion from './components/public-opinion/index'
import mixin from './mixin'

export default {
  mixins: [mixin],
  components: {
    business,
    judicial,
    manage,
    unpromise,
    publicOpinion,
  },
  data() {
    return {}
  },
  mounted() {
    // this.handleChange('1')
  },
  methods: {
    // handleChange(activeKey) {
    //   console.log(activeKey)
    //   const self = this
    //   this.$confirm({
    //     title: '提示?',
    //     content: '此接口收费，确定继续前往吗？',
    //     onOk() {
    //       self.activeKey = activeKey
    //     },
    //     onCancel() {
    //       console.log('onCancel')
    //     }
    //   })
    // }
  },
}
</script>
<style scoped lang="less">
.lengj-data {
  /deep/ .anchor-wrap {
    position: fixed;
    right: 30px;
    top: 240px;
    z-index: 2;
  }
}
</style>
